import Request from "./index";
import axios from "axios";


export const postDocumentName = (data: Object) =>
  Request.post("order-pdf-presigned-url/", data);

export const uploadDocument = async (url:any, data: any) => {
  const response = await axios.put(url, data, {
    headers: {
      "x-amz-acl": "public-read",
      "Content-Type": "application/pdf"
    },
  });
  return response;
}


export const sendEmailData = (data: any) => 
  Request.post("share-order-pdf/", data);

export const sendEmailNonSupplier = (data: any) => 
  Request.post("share-order-pdf/?invite=True", data);

export const sendSupplierEmailData = (data: any) =>
  Request.post(
    "share-order-pdf/?auto_supplier=True",
    data
  );